import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

export interface StepperStepStyle {
  iconColor: string | undefined;
  labelColor: string | undefined;
  size: string;
}

export const stepperStepStyleMap = new Map<string, StepperStepStyle>([
  [
    "current",
    {
      iconColor: nawyTheme.nawy.colors.semantic.indicator.blue,
      labelColor: nawyTheme.nawy.colors.semantic.text.accent,
      size: "20px",
    },
  ],
  [
    "finished",
    {
      iconColor: nawyTheme.nawy.colors.semantic.indicator.blue,
      labelColor: nawyTheme.nawy.colors.semantic.text.accent,
      size: "20px",
    },
  ],
  [
    "null",
    {
      iconColor: nawyTheme.nawy.colors.semantic.indicator.grey,
      labelColor: nawyTheme.nawy.colors.semantic.text.secondary,
      size: "17.5px",
    },
  ],
]);
